import React from "react";
import { Box, CircularProgress } from "@mui/material";

const LoadingIndicator: React.FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingIndicator;
